import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getCategoryURL } from '../../../helpers/shop/shopHelper';

import {
    Grid, List, ListItem, Typography, ListItemText, ListItemButton,
    Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const SubcategorySidebar = ({ url, selectedIndex, subcategories, setSelectedCategory }) => {
    const navigate = useNavigate();

    //Acordion
    const [expanded, setExpanded] = React.useState('panel1');
    const handleChangeAccordion = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    // selección de subcategoría
    const subcategorySelected = subcategory => () => {
        setSelectedCategory(e => ({
            ...e, subcategory
        }));
        navigate(`/tienda/categoria/${url}/${getCategoryURL(subcategory)}`);
    };

    return (
        <Grid item xl={2} lg={3} md={12} sm={12} xs={12}>
            <Accordion expanded={ expanded === 'panel1' }
                onChange={ handleChangeAccordion('panel1') }>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Subcategorías</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '0' }}>
                    <List>
                        {
                            subcategories.map((e, i) =>
                                <ListItem disablePadding key={e}
                                    onClick={ subcategorySelected(e) }>
                                    <ListItemButton component="a"
                                        selected={ selectedIndex === i }>
                                        <ListItemText secondary={e} />
                                    </ListItemButton>
                                </ListItem>
                            )
                        }
                            <ListItem disablePadding
                                onClick={ subcategorySelected('VER TODO') }>
                                <ListItemButton component="a"
                                    selected={ selectedIndex === -1 }>
                                    <ListItemText secondary="VER TODO" />
                                </ListItemButton>
                            </ListItem>
                    </List>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

export default SubcategorySidebar;